"use strict";
import _ from "underscore";
var ObjectWithIDStore = function(storeType, alwaysSendsNotifications) {
  return {
    items: [],
    index: {},
    type: storeType || "unknown",
    find: function(id) {
      return this.index[id];
    },
    findAll: function(ids) {
      return _.map(ids, this.find.bind(this));
    },
    addOrUpdate: function(item) {
      var existing = this.index[item.id];
      if (existing) {
        _.extend(existing, item);
        this.notifyOfChange(item);
        return existing;
      } else {
        this.items.push(item);
        this.index[item.id] = item;
        this.notifyOfChange(item);
        return item;
      }
    },
    destroy: function(item) {
      var existing = this.index[item.id];
      if (existing) {
        delete this.index[item.id];
        var idx = _.indexOf(this.items, item);
        this.items.splice(idx, 1);
        this.notifyOfChange(item);
      }
      return item;
    },
    addOrUpdateAll: function(items) {
      return _.map(items, this.addOrUpdate.bind(this));
    },
    notificationsEnabled: false,
    enableNotifications: function() {
      this.notificationsEnabled = true;
    },
    disableNotifications: function() {
      this.notificationsEnabled = false;
    },
    notifyOfChange: function(item) {
      if (alwaysSendsNotifications || this.notificationsEnabled) {
        $(this).trigger("storeItemChanged:" + this.type + ":" + item.id, { item });
        $(this).trigger("storeChanged:" + this.type, {});
      }
    }
  };
};
export default ObjectWithIDStore;
